// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://dashboard.lono.co.in/api';

// Other configuration constants can be added here
